/**
 * How many messages before and after the reported message to include in evidence.
 * Must stay in sync with API validation and report submission service.
 */
export const REPORT_CONTEXT_MESSAGE_COUNTS = [3, 5, 10, 25];
export function isReportContextMessageCount(n) {
    return REPORT_CONTEXT_MESSAGE_COUNTS.includes(n);
}
//# sourceMappingURL=report-context.js.map